import { defineMessages } from "react-intl";
const messages = defineMessages({
    noScanRequests: {
        id: "app.scanRequests.table.tooltip.noData",
        defaultMessage: "No Scan Requests available.",
    },
    editTooltip: {
        id: "app.scanRequests.table.tooltip.edit",
        defaultMessage: "Edit Scan Request",
    },
    address: {
        id: "app.scanRequests.table.column.address",
        defaultMessage: "Address",
    },
    requestedBy: {
        id: "app.scanRequests.table.column.requestedBy",
        defaultMessage: "Requested By",
    },
    community: {
        id: "app.scanRequests.table.column.community",
        defaultMessage: "Community",
    },
    requestedOn: {
        id: "app.scanRequests.table.column.requestedOn",
        defaultMessage: "Requested On",
    },
    organization: {
        id: "app.scanRequests.table.column.organization",
        defaultMessage: "Organization",
    },
    space: {
        id: "app.scanRequests.table.column.space",
        defaultMessage: "Space",
    },
    floorPlan: {
        id: "app.scanRequests.table.column.floorplan",
        defaultMessage: "Floorplan",
    },
    buildingName: {
        id: "app.scanRequests.table.column.buildingName",
        defaultMessage: "Building",
    },
    scannerEmail: {
        id: "app.scanRequests.table.column.scannerEmail",
        defaultMessage: "Scanner Email",
    },
    availableFrom: {
        id: "app.scanRequests.table.column.availableFrom",
        defaultMessage: "Available From",
    },
    status: {
        id: "app.scanRequests.table.column.status",
        defaultMessage: "Status",
    },
    scheduledFor: {
        id: "app.scanRequests.table.column.scheduledFor",
        defaultMessage: "Scheduled For",
    },
    scheduledCommunitySelect: {
        id: "app.scanRequests.table.column.schedule.communitySelect",
        defaultMessage: "Please, select at least one Scan Request",
    },
    scheduledCommunityConfirm: {
        id: "app.scanRequests.table.column.schedule.communityConfirm",
        defaultMessage: "Scan Request of Space {space} Scheduled",
    },
    scanRequestsSpaceUnitFilter: {
        id: "app.scanRequests.table.column.space.filter.unit",
        defaultMessage: "Unit",
    },
    scanRequestsSpaceAmenityFilter: {
        id: "app.scanRequests.table.column.space.filter.amenity",
        defaultMessage: "Amenity",
    },
    scanRequestsStatusSkippedFilter: {
        id: "app.scanRequests.table.column.space.status.skipped",
        defaultMessage: "Skipped",
    },
    scanRequestsStatusRequestedFilter: {
        id: "app.scanRequests.table.column.space.status.requested",
        defaultMessage: "Requested",
    },
    scanRequestsStatusScheduledFilter: {
        id: "app.scanRequests.table.column.space.status.scheduled",
        defaultMessage: "Scheduled",
    },
    scanRequestsStatusCanceledFilter: {
        id: "app.scanRequests.table.column.space.status.canceled",
        defaultMessage: "Canceled",
    },
    scanRequestsSelectCommunity: {
        id: "app.scanRequests.selectCommunity.error",
        defaultMessage: "Select a community to visualize its details.",
    },
    autoScanLabel: {
        id: "app.scanRequests.table.column.autoScan",
        defaultMessage: "Autoscan",
    },
    rescan: {
        id: "app.scanRequests.table.column.rescan",
        defaultMessage: "Re-scan",
    },
});
export default messages;
